import type { $Fetch } from "nitropack";

export interface MatchingWeights {
    deal_size_weight: number;
    market_segment_weight: number;
    persona_weight: number;
    industry_weight: number;
    company_size_weight: number;
}

export const MatchingWeightsRepository = (client: $Fetch) => ({
    get: (companyId: string, config?: any): Promise<MatchingWeights> => {
        return client(`/v2/companies/${companyId}/matching-weights`, {
            ...config,
        });
    },

    update: (companyId: string, weights: MatchingWeights, config?: any): Promise<MatchingWeights> => {
        return client(`/v2/companies/${companyId}/matching-weights`, {
            ...config,
            method: 'PUT',
            body: weights,
        });
    },
});
